import api from "../api";

export default {
    index() {
        return api.get('/central/teams')
    },

    store() {
        return api.post('/central/teams')
    }
}